import React from 'react';
import { Row, Col } from 'react-bootstrap';
import CopyLink from '../components/copy-link';
import Article from '../components/article';
import Layout from '../layouts/default-layout';
import SEO from '../components/seo';
import useSiteMetadata from '../hooks/use-site-metadata';
import DownloadOverlay from '../components/download-overlay';
import PrimaryLogoSVG from '../components/svgs/primary-logo';
import SecondaryLogoSVG from '../components/svgs/secondary-logo';
import LogoMarkSVG from '../components/svgs/logo-mark';
import LogoMarkSpecsSVG from '../components/svgs/logo-mark-specs';
import PrimaryLogoClearanceSVG from '../components/svgs/primary-logo-clearance';
import SecondaryLogoClearanceSVG from '../components/svgs/secondary-logo-clearance';
import LogoMarkClearanceSVG from '../components/svgs/logo-mark-clearance';
var BrandHeartPage = function BrandHeartPage(_ref) {
    var location = _ref.location;
    var _useSiteMetadata = useSiteMetadata(), siteURL = _useSiteMetadata.siteURL;
    var canonicalUrl = "" + siteURL + location.pathname;
    var pageTitle = 'Visual Identity';
    var articles = [
        {
            articleTitle: 'Primary Logo',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "50%",
                className: "svg-fill-beige mx-auto d-block mb-6"
            }), /*#__PURE__*/ React.createElement("p", {
                className: "text-center mb-0"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "https://supervillain.download/rDya0z",
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-outline-dark"
            }, "Download Primary Logo")))
        },
        {
            articleTitle: 'Primary Logo Alts',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-beige p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/xOP10y"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-cream mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-cream p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/geBkbM"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-beige mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-white p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/yEfpTc"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-dark mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4,
                className: "mb-4 mb-lg-0"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-beige p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/fbpdKG"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-white mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-cream p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/yEfpTc"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-dark mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                lg: 4
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-dark p-5 p-md-6 p-lg-5 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/fbpdKG"
            }), /*#__PURE__*/ React.createElement(PrimaryLogoSVG, {
                width: "100%",
                className: "svg-fill-white mx-auto d-block"
            })))), /*#__PURE__*/ React.createElement("p", {
                className: "text-center mb-0"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "https://supervillain.download/dI7Dht",
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-outline-dark"
            }, "Download Primary Logos")))
        },
        {
            articleTitle: 'Primary Logo Clearance',
            articleContent: /*#__PURE__*/ React.createElement(PrimaryLogoClearanceSVG, {
                width: "60%",
                svgClassName: "mx-auto d-block",
                clearanceClassName: "svg-fill-beige svg-opacity-50",
                specsClassName: "svg-stroke-dash-dark",
                specMarkersClassName: "svg-fill-dark",
                logoClassName: "svg-fill-beige"
            })
        },
        {
            articleTitle: 'Secondary Logo',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SecondaryLogoSVG, {
                width: "66%",
                className: "svg-fill-beige mx-auto d-block mb-6"
            }), /*#__PURE__*/ React.createElement("p", {
                className: "text-center mb-0"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "https://supervillain.download/qh8XPp",
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-outline-dark"
            }, "Download Secondary Logo")))
        },
        {
            articleTitle: 'Secondary Logo Clearance',
            articleContent: /*#__PURE__*/ React.createElement(SecondaryLogoClearanceSVG, {
                width: "80%",
                svgClassName: "mx-auto d-block",
                clearanceClassName: "svg-fill-beige svg-opacity-50",
                specsClassName: "svg-stroke-dash-dark",
                specMarkersClassName: "svg-fill-dark",
                logoClassName: "svg-fill-beige"
            })
        },
        {
            articleTitle: 'Logomark',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-beige p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/ypLYrI"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-cream mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-cream p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/V6gj3t"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-beige mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4,
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-white p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/QKNMsg"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-dark mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4,
                className: "mb-4 mb-lg-0"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-beige p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/w9c88b"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-white mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-cream p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/QKNMsg"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-dark mx-auto d-block"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                sm: 4
            }, /*#__PURE__*/ React.createElement("div", {
                className: "bg-dark p-5 p-md-6 position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/w9c88b"
            }), /*#__PURE__*/ React.createElement(LogoMarkSVG, {
                width: "100%",
                className: "svg-fill-white mx-auto d-block"
            })))), /*#__PURE__*/ React.createElement("p", {
                className: "text-center mb-0"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "https://supervillain.download/2Bc9xo",
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-outline-dark"
            }, "Download Logomarks")), /*#__PURE__*/ React.createElement("div", {
                className: "border-top mt-6 pt-6"
            }, /*#__PURE__*/ React.createElement(LogoMarkSpecsSVG, {
                width: "65%",
                svgClassName: "mx-auto d-block",
                fillClassName: "svg-fill-beige",
                dashClassName: "svg-stroke-dash-rust",
                strokeClassName: "svg-stroke-rust"
            })))
        },
        {
            articleTitle: 'Logomark Clearance',
            articleContent: /*#__PURE__*/ React.createElement(LogoMarkClearanceSVG, {
                width: "45%",
                svgClassName: "mx-auto d-block",
                clearanceClassName: "svg-fill-beige svg-opacity-50",
                specsClassName: "svg-stroke-dash-dark",
                specMarkersClassName: "svg-fill-dark",
                logoClassName: "svg-fill-beige"
            })
        },
        {
            articleTitle: 'Font Families',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-6 text-center"
            }, "Canela Font Family"), /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-center mb-0"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/canela-light.svg",
                alt: "Canela Light"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "offset-md-1"
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/canela-light-italic.svg",
                alt: "Canela Light Italic"
            }))), /*#__PURE__*/ React.createElement("div", {
                className: "border-top mt-6 pt-6"
            }, /*#__PURE__*/ React.createElement("h3", {
                className: "h5 font-weight-bolder mb-6 text-center"
            }, "Passenger Sans Font Family"), /*#__PURE__*/ React.createElement(Row, {
                className: "justify-content-around"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-light.svg",
                alt: "Passenger Sans Light"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-light-italic.svg",
                alt: "Passenger Sans Light Italic"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "mb-5"
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-regular.svg",
                alt: "Passenger Sans Regular"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "mb-5 mb-md-0"
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-regular-italic.svg",
                alt: "Passenger Sans Regular Italic"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-semibold.svg",
                alt: "Passenger Sans Semibold"
            })), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4
            }, /*#__PURE__*/ React.createElement("img", {
                src: "/passanger-bold.svg",
                alt: "Passenger Sans bold"
            })))))
        },
        {
            articleTitle: 'Colors',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                noGutters: true
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "min-h-100"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "pt-6 pt-sm-7 pt-md-8 pb-4 px-4 bg-dark h-100 border-left border-top"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "small text-light"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-2 font-weight-bolder"
            }, "Black"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-light",
                btnClassName: "btn-dark mr-1",
                text: "#191414",
                label: "Copy HEX Code"
            }), ' ', "#191414"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-light",
                btnClassName: "btn-dark mr-1",
                text: "25, 20, 20",
                label: "Copy RGB Code"
            }), ' ', "R25/G20/B20"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-light",
                btnClassName: "btn-dark mr-1",
                text: "0, 0, 0, 100",
                label: "Copy CMKY Code"
            }), ' ', "C0/M0/Y0/K100")))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "min-h-100"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "pt-6 pt-sm-7 pt-md-8  b-4 px-4 bg-beige h-100 border-top border-right border-right-md-0"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "small"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-2 font-weight-bolder"
            }, "Beige"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-beige mr-1",
                text: "#C4B2A5",
                label: "Copy HEX Code"
            }), ' ', "#C4B2A5"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-beige mr-1",
                text: "196, 178, 165",
                label: "Copy RGB Code"
            }), ' ', "R196/G178/B165"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-beige mr-1",
                text: "24, 27, 33, 0",
                label: "Copy CMKY Code"
            }), ' ', "C24/M27/Y33/K0")))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 4,
                className: "min-h-100"
            }, /*#__PURE__*/ React.createElement("div", {
                className: "pt-6 pt-sm-7 pt-md-8 pb-4 px-4 bg-rust h-100 border-left border-left-md-0 border-top-md border-right-md"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "small"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-2 font-weight-bolder"
            }, "Rust"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-rust mr-1",
                text: "#A54F2D",
                label: "Copy HEX Code"
            }), ' ', "#A54F2D"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-rust mr-1",
                text: "165, 79, 45",
                label: "Copy RGB Code"
            }), ' ', "R165/G79/B45"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-rust mr-1",
                text: "25, 77, 98, 16",
                label: "Copy CMKY Code"
            }), ' ', "C25/M77/Y98/K16")))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6,
                md: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "pt-6 pt-sm-7 pt-md-8 pb-4 px-4 bg-white border-right border-left-md border-bottom-md border-right-md-0"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "small"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-2 font-weight-bolder"
            }, "White"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-white mr-1",
                text: "#FFFFFF",
                label: "Copy HEX Code"
            }), ' ', "#FFFFFF"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-white mr-1",
                text: "255, 255, 255",
                label: "Copy RGB Code"
            }), ' ', "R255/G255/B255"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-white mr-1",
                text: "0, 0, 0, 0",
                label: "Copy CMKY Code"
            }), ' ', "C0/M0/Y0/K0")))), /*#__PURE__*/ React.createElement(Col, {
                xs: 12,
                md: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "pt-6 pt-sm-7 pt-md-8 pb-4 px-4 bg-cream border-left border-left-md-0 border-right border-bottom"
            }, /*#__PURE__*/ React.createElement("span", {
                className: "small"
            }, /*#__PURE__*/ React.createElement("p", {
                className: "mb-2 font-weight-bolder"
            }, "Cream"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-cream mr-1",
                text: "#F7EDE7",
                label: "Copy HEX Code"
            }), ' ', "#F7EDE7"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-1"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-cream mr-1",
                text: "247, 237, 231",
                label: "Copy RGB Code"
            }), ' ', "R247/G237/B231"), /*#__PURE__*/ React.createElement("p", {
                className: "mb-0"
            }, /*#__PURE__*/ React.createElement(CopyLink, {
                iconClassName: "svg-fill-dark",
                btnClassName: "btn-cream mr-1",
                text: "2, 6, 7, 0",
                label: "Copy CMKY Code"
            }), ' ', "C2/M6/Y7/K0"))))))
        },
        {
            articleTitle: 'Icons & Patterns',
            articleContent: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Row, {
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/9hZEiW"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/icon-beige.svg",
                alt: "Icon Beige"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/9hZEiW"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/icon-cream.svg",
                alt: "Icon Cream"
            })))), /*#__PURE__*/ React.createElement(Row, {
                className: "mb-4"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/6DAaTf"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/pattern-a-cream.svg",
                alt: "Icon Cream"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/6DAaTf"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/pattern-a-beige.svg",
                alt: "Icon Beige"
            })))), /*#__PURE__*/ React.createElement(Row, {
                className: "mb-6"
            }, /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/UnwtqN"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/pattern-b-beige.svg",
                alt: "Icon Beige"
            }))), /*#__PURE__*/ React.createElement(Col, {
                xs: 6
            }, /*#__PURE__*/ React.createElement("div", {
                className: "position-relative"
            }, /*#__PURE__*/ React.createElement(DownloadOverlay, {
                label: "Download",
                url: "https://supervillain.download/UnwtqN"
            }), /*#__PURE__*/ React.createElement("img", {
                src: "/pattern-b-cream.svg",
                alt: "Icon Cream"
            })))), /*#__PURE__*/ React.createElement("p", {
                className: "text-center mb-0"
            }, /*#__PURE__*/ React.createElement("a", {
                href: "https://supervillain.download/95xUJB",
                target: "_blank",
                rel: "noreferrer",
                className: "btn btn-outline-dark"
            }, "Download Icons & Patterns")))
        }
    ];
    return /*#__PURE__*/ React.createElement(Layout, null, /*#__PURE__*/ React.createElement(SEO, {
        title: pageTitle
    }), articles.map(function (item, index) {
        var itemKey = "article-" + index;
        return /*#__PURE__*/ React.createElement(Article, {
            title: item.articleTitle,
            pageUrl: canonicalUrl,
            key: itemKey
        }, item.articleContent);
    }));
};
export default BrandHeartPage;
